import React, { useEffect, useState } from "react";
import { PropTypes } from "prop-types";
import DynamicTable from "../components/dynamicTable";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function TimeSheetReport({ appState }) {
  const todayMinus1 = moment().subtract(1, "days").format("MM/DD/YYYY");
  const startDate = moment(`${todayMinus1}`, "MM/DD/YYYY")
    .startOf("month")
    .toString();
  const endDate = moment().subtract(1, "days").toString();

  const [body, setBody] = useState([]);
  const [startD, setStartD] = useState(startDate);
  const [endD, setEndD] = useState(endDate);

  const [state, setState] = useState({
    loading: false,
    response: "default",
  });
  const [reloadData, setReloadData] = useState({
    action: false,
  });

  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    setState((state) => ({
      ...state,
      loading: body.length === 0,
    }));
  }, [body, state.loading, state.response]);

  useEffect(() => {
    if (reloadData.action) {
      getData();
    }
  }, [reloadData.action, body]);

  const getDailyClosing = async (location) => {
    const { siteId, locationId, siteName, token } = location;

    const getData = {
      method: "GET",
      headers: {
        "Content-type": "applicationjson; charset=UTF-8",
        siteid: siteId,
        authorization: token,
        locationid: locationId,
      },
    };
    const searchStartDate = moment(startD).format("MM/DD/YYYY");
    const searchEndDate = moment(endD).format("MM/DD/YYYY");

    const request = `${process.env.REACT_APP_API_URL}/api/sites/${siteId}/locations/${locationId}/timeSheet?startDate=${searchStartDate}&endDate=${searchEndDate}`;
    const response = await fetch(request, getData);

    const res = await response.json();

    if (response.ok) {
      const data = {
        data: res,
        siteId: siteId,
        locationId: locationId,
        siteName: siteName,
      };
      return Promise.resolve(data);
    } else {
      return Promise.resolve({
        error: res.message,
        siteId: siteId,
        locationId: locationId,
        siteName: siteName,
      });
    }
  };

  const getData = async () => {
    setState((state) => ({
      ...state,
      response: "loading",
    }));

    try {
      const dataRequests = await getDailyClosing({
        siteId: appState.nav.siteId,
        locationId: appState.nav.locationId,
        siteName: appState.nav.siteName,
        token: appState.singleAuth.token,
      });

      if (!dataRequests.data && dataRequests.error) {
        setErrorMessage(
          dataRequests.error ===
            "request error, invalid range date!, limit 30 days"
            ? "invalid range date (limit one month)."
            : dataRequests.error === "Not data found"
            ? "There is no weather report for this date range."
            : dataRequests.error + "."
        );
        setBody([]);
      } else {
        const data = dataRequests.data;

        setBody(transformJSON(data));
      }
      setReloadData((reloadData) => ({
        ...reloadData,
        action: false,
      }));
      setState((state) => ({
        ...state,
        response: "default",
      }));
    } catch (error) {
      setState((state) => ({
        ...state,
        response: "error",
      }));
      setReloadData((reloadData) => ({
        ...reloadData,
        action: false,
      }));
      setBody([]);
    }
  };

  const handleDateRangeSearch = () => {
    setReloadData((reloadData) => ({
      ...reloadData,
      action: true,
    }));
  };

  function transformJSON(inputJSON) {
    const items = inputJSON.items;

    const result = [];

    for (const item of items) {
      const date = item.date;
      const employees = item.employeesTimeSheet;

      for (const employee of employees) {
        result.push({
          Date: date,
          Name: employee.Name,
          arrival: employee.arrival,
          checkOut: employee.checkOut,
          Notes: employee.Notes,
        });
      }
    }

    return result;
  }

  return (
    <div className="container mt-4">
      <>
        <h2
          className="text-center lb-title-daily extraclass"
          data-cy="timesheet-report"
        >
          Time Sheet Report
        </h2>
        <div
          className="d-flex justify-content-center"
          style={{ marginTop: "8%" }}
        >
          <div className="col-6 d-flex text-center">
            <div className="col-6 d-block">
              <h5 className="lb-title-daily">Start</h5>
              <DatePicker
                selected={new Date(startD)}
                dateFormat="MM/dd/yyyy"
                onChange={(date) => setStartD(date)}
                className="form-control mr-3"
              />
            </div>

            <div className="col-6 d-block">
              <h5 className="lb-title-daily">End</h5>
              <DatePicker
                selected={new Date(endD)}
                dateFormat="MM/dd/yyyy"
                onChange={(date) => setEndD(date)}
                className="form-control ml-3"
                minDate={new Date(startD)}
              />
            </div>

            <div style={{ marginTop: "5%" }}>
              <button
                data-cy="btn-search-projection-report-data"
                className="btn border text rounded-pill btn-sm ml-4 pt-2 pb-2"
                onClick={(e) => {
                  handleDateRangeSearch(e);
                }}
                style={{
                  color: "white",
                  width: 65,
                  backgroundColor: "#c2608e",
                  borderColor: "#c2608e #c2608e #fff",
                }}
              >
                <FontAwesomeIcon icon={faSearch} style={{ fontSize: 20 }} />
              </button>
            </div>
          </div>
        </div>

        {body.length > 0 ? (
          <section id="table" className="mt-4">
            <DynamicTable
              fileName={"TimeSheetReport.pdf"}
              headers={["DATE", "NAME", "ARRIVAL", "CHECK OUT", "NOTES"]}
              rows={body}
              setReloadData={setReloadData}
              reloadData={reloadData}
              title={"Time Sheet Report"}
              subTitle={`${moment(startD).format("MM/DD/YYYY")} - ${moment(
                endD
              ).format("MM/DD/YYYY")}`}
              type={"xlsx"}
            />
          </section>
        ) : (
          <p
            className="text-center lb-title-daily extraclass"
            style={{ marginTop: "8%", fontSize: "1.2rem" }}
            data-cy="timesheet-report"
          >
            {errorMessage}
          </p>
        )}
      </>
    </div>
  );
}

TimeSheetReport.propTypes = {
  appState: PropTypes.object.isRequired,
};

export default TimeSheetReport;
